import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { environment } from 'src/environments/environment';
import { ApiService } from 'src/app/services/api.service';
import { UtilityService } from 'src/app/services/utility.service';
import { Router, ActivatedRoute } from '@angular/router';

@Component({
    selector: 'app-terms',
    templateUrl: './terms.component.html',
    styleUrls: ['./terms.component.scss'],
    standalone: false
})
export class TermsComponent implements OnInit {

  assets=environment.assets;
  verificationToken: string;
  userId: string;
  
  constructor(
    public dialogRef: MatDialogRef<TermsComponent>,
    private api: ApiService,
    private utility: UtilityService,
    private router: Router,
    private route: ActivatedRoute,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.initializeVerification();
  }

  ngOnInit(): void {
  }

  private initializeVerification() {
    // Get verification token from URL
    const urlParts = this.router.url.split('/');
    this.verificationToken = urlParts[urlParts.length - 1];
    
    if (this.verificationToken) {
      this.verifyEmailToken();
    }
  }

  private verifyEmailToken() {
    this.api.apiRequest('post', 'user/verifyEmail', { tokens: this.verificationToken })
      .subscribe({
        next: (response: any) => {
          if (response?.data?.userId) {
            this.userId = response.data.userId;
          } else {
            this.handleError('No userId found for token');
          }
        },
        error: (error) => {
          this.handleError('Error getting user details', error);
        }
      });
  }

  modalClose = (action = 'X') => {
    if (action === 'Accept') {
      if (!this.userId) {
        this.handleError('No userId available');
        return;
      }
      this.updateTerms(this.userId, action);
    } else {
      this.dialogRef.close(action);
    }
  }

  private updateTerms(userId: string, action: string) {
    const payload = {
      isTermsAccepted: true
    };

    this.api.apiRequest('put', `user/${userId}/terms`, payload).subscribe({
      next: (response) => {
        this.utility.openSnackBar('Terms accepted successfully', 'Ok');
        this.dialogRef.close(action);
        this.router.navigate(['/auth/signin']);
      },
      error: (error) => {
        const errorMessage = error?.error?.message || 'Error accepting terms. Please try again.';
        this.utility.openSnackBar(errorMessage, 'Ok');
      }
    });
  }

  private handleError(message: string, error?: any) {
    console.error(message, error);
    this.utility.openSnackBar(`${message}. Please try again.`, 'Ok');
    this.dialogRef.close('error');
  }

}
